import React from 'react';
import { Row } from 'antd';
import { Formik, Form as FormikForm } from 'formik';
import Logo from 'assets/logo/logo_full.png';
import styles from './CompanyAddress.module.scss';
import InputField from 'shared/components/InputField';
import COButton from 'shared/components/COButton';
import {
  Fields,
  validationSchema,
  initialValues,
} from './AddressFormConstants';
import { useLocation, useNavigate } from 'react-router-dom';
import { CompanyAddressFormPropsEnum } from 'enums/CompanyAddressFormEnum';
import UserCompanyService from 'services/AuthenticationService/userCompany.service';

const CompanyAddressForm = () => {
  const { getCompanyAddress, buttonLoading } = UserCompanyService();
  const navigate = useNavigate();
  const location = useLocation();
  const companyId = Number(location.state?.id);
  const handleGoBack = () =>  navigate(-1);
  
  const company = localStorage.getItem('userDetails');
  let companyParse: { id: number; company_id: number };
  if (company !== null) {
    companyParse = JSON.parse(company);
  }
  const handleApiSubmission = async (values: {
    streetlocality: string;
    province: string;
    city: string;
    postalcode: string;
    country: string;
  }) => {
    getCompanyAddress(companyParse?.id, {
      street: values.streetlocality,
      province: values.province,
      city: values.city,
      postal_code: values.postalcode,
      country: values.country,
      addressable_type: CompanyAddressFormPropsEnum.ADDRESSABLE_TYPE,
      addressable_id: companyId ? companyId : companyParse?.company_id,
    });
  };

  return (
    <div className={styles.formContainer}>
      <Row className={styles.logoContainer}>
        <img
          src={Logo}
          alt={CompanyAddressFormPropsEnum.IMAGE_ALT}
          className={styles.logo}
        />
      </Row>
      <Row className={styles.headingContainer}>
        <div>
          <h1>{CompanyAddressFormPropsEnum.PAGE_TITLE}</h1>
        </div>
      </Row>
      <div className={styles.fieldsContainer}>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={values => handleApiSubmission(values)}>
          {formik => (
            <FormikForm>
              {Fields.map((field, index) => {
                return (
                  <div key={index} className={styles.fieldContainer}>
                    <InputField
                      name={field.name}
                      placeholderstring={field.placeholder}
                      label={field.label}
                    />
                  </div>
                );
              })}
              <div className={styles.buttonContainer}>
                <COButton
                  submit
                  loading={buttonLoading}
                  disabled={!formik.isValid}>
                  {CompanyAddressFormPropsEnum.BUTTON_LABEL_SUBMIT}
                </COButton>
                <COButton secondary onClick={handleGoBack}>
                  {CompanyAddressFormPropsEnum.BUTTON_LABEL_BACK}
                </COButton>
              </div>
            </FormikForm>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default CompanyAddressForm;
